import { useI18n } from 'next-localization';

import { cn } from '@/lib/utils';
import { NeuIcon } from '@hcahealthcaredpx/neutron-react';

import styles from './distance.module.css';

type DistanceProps = {
  distance?: string | number | null;
  isBold?: boolean;
  showIcon?: boolean;
};

export const Distance = ({
  distance,
  isBold = true,
  showIcon = false,
}: DistanceProps): JSX.Element | null => {
  const { t } = useI18n();

  if (!distance) {
    return null;
  }

  const fontWeight = isBold ? 'fw-bold' : 'fw-normal';

  return (
    <span className={cn('text-lowercase', fontWeight, styles.distance)}>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-expect-error */}
      {showIcon && <NeuIcon name="room" aria-hidden="true" className={styles.locationIcon} />}
      <span className="sr-only">{t('OAS.Listing.Accessibility.DistanceFromYou')}</span>
      {distance} {t('OAS.ChangeLocation.Miles')}
    </span>
  );
};
